module.exports = __webpack_public_path__ + "img/wheelchair.67239c42.svg";